import {
  COMPLIANCE_DOCUMENT_STATUS,
  COMPLIANCE_DOCUMENT_STATUS_VALUES,
  ComplianceDocumentStatusTypes,
} from 'domain/shared/compliance';
import { Badge } from 'framework/ui/mui-builder';
import { FieldProps, useFieldHelper } from 'framework/ui/field';

const ComplianceDocumentStatusBadgeField = ({ source }: FieldProps) => {
  const { getValue } = useFieldHelper<ComplianceDocumentStatusTypes>({ source });

  const status = getValue();

  return (
    <Badge color={status === COMPLIANCE_DOCUMENT_STATUS.UNPUBLISHED ? 'default' : 'success'}>
      {COMPLIANCE_DOCUMENT_STATUS_VALUES[status] || COMPLIANCE_DOCUMENT_STATUS_VALUES.UNPUBLISHED}
    </Badge>
  );
};

export default ComplianceDocumentStatusBadgeField;
